import { LessonForm, SubjectArea } from 'components/submit/SubmitForm/types';
import { Subject } from 'models';
import ContentSubject from 'models/ContentSubject';
import Lesson, { BasicInfo, EducatorInfo, SubjectBasedValues, SubjectInfo } from 'models/Lesson';

export function formatFormData(formValues: LessonForm): Lesson {
  const formattedBasicInfo: BasicInfo = {
    gradeLevels: formValues.basicInfo.gradeLevels,
    lessonTitle: formValues.basicInfo.lesson.title,
    lessonDescription: formValues.basicInfo.lesson.description,
    cstaStandards: convertCommaStringToArray(formValues.basicInfo.cstaStandards)
  };

  const formattedPersonalInfo: EducatorInfo = {
    displayPublicly: formValues.personalInformation.displayInfo,
    educatorName: formValues.personalInformation.name,
    emailAddress: formValues.personalInformation.email,
    schoolDistrict: formValues.personalInformation.school.district,
    schoolName: formValues.personalInformation.school.name,
    schoolState: formValues.personalInformation.school.state,
    schoolZipCode: formValues.personalInformation.school.zip ?? null,
    twitterId: formValues.personalInformation.twitter,
  };

  const formattedUpload: Pick<Lesson, 'lessonFileId'> = {
    lessonFileId: formValues.upload,
  };

  const formattedSubjectInfo = formatSubjectInfo(formValues.subjectAreas as SubjectArea[]);

  return {
    ...formattedBasicInfo,
    ...formValues.permissions,
    ...formattedPersonalInfo,
    ...formValues.techRequirements,
    ...formattedUpload,
    ...formattedSubjectInfo,
    lessonId: '',
    submissionApproved: false,
  };
}

function formatSubjectInfo(subjectAreaSection: SubjectArea[]): SubjectInfo {
  const subjectAreas: Subject[] = [];
  let mnStandards: SubjectBasedValues = {};
  let contentStrands: SubjectBasedValues = {};

  subjectAreaSection.forEach((subjectArea) => {
    const subject = subjectArea.subject as ContentSubject;

    subjectAreas.push(SubjectMapping[subject]);

    if(subject !== ContentSubject.ComputerScience) {
      contentStrands[subject] = subjectArea.contentStrands;
      mnStandards[subject] = [subjectArea.mnStandards];
    }
  });

  return {
    subjectAreas,
    mnStandards,
    contentStrands,
  };
}

const SubjectMapping = {
  [ContentSubject.Art]: Subject.ART,
  [ContentSubject.ComputerScience]: Subject.COMPUTER_SCIENCE,
  [ContentSubject.English]: Subject.LANGUAGE_ARTS,
  [ContentSubject.Math]: Subject.MATH,
  [ContentSubject.Science]: Subject.SCIENCE,
  [ContentSubject.SocialStudies]: Subject.SOCIAL_STUDIES,
};

function convertCommaStringToArray(stringWithCommas: string | undefined): string[] {
  if (!stringWithCommas || stringWithCommas.length === 0) {
    return [];
  }  
  
  var stringWithoutSpaces = stringWithCommas.replace(/\s{0,},\s{1,}/g,',');
  
  return stringWithoutSpaces.split(',');
}
